import * as menuDataStub from '../../../workflow/components/sidebar/projektsidebar.component.spec.json';
import * as workflowStub from './demo-workflow.json';
import { Component, Injectable, ViewChild } from '@angular/core';
import { WizardPage } from '@app/workflow/components/navigator/wizard-view/interfaces';
import { Observable, of } from 'rxjs';
import { provideMockStore } from '@ngrx/store/testing';
import { SessionItemData } from '../../../workflow/services/session-item-data';
import { WorkflowCategory, WorkflowService } from '../../../workflow/services/workflow.service';
import { WorkflowItemData } from '@api/projects/interfaces';
import { WorkflowItemDirective } from '../../../workflow/directives/workflow-item/workflow-item.directive';
import { WorkflowRestService } from '../../../services/rest/workflow-rest.service';
import { IQuestionnaireWorkflowItem, IWorkflow } from '@interfaces/interfaces';
import { DistractionFreeWizardService } from '@app/pages/questions/distraction-free-wizard.service';

@Injectable()
class WorkflowRestServiceStub implements Partial<WorkflowRestService> {
	value: WorkflowItemData = {pid: 'pid', itemid: 'item', data: {}};

	getWorkflowItemStatus$(): Observable<WorkflowItemData> {
		return of(this.value);
	}

	updateStatus$(projectID: string, pid: string, itemId: string, data: Partial<WorkflowItemData>): Observable<WorkflowItemData> {
		this.value = {...this.value, data: data.data};
		return of(this.value);
	}
}

@Injectable()
class workflowServiceStub implements Partial<WorkflowService> {
	get workflow() { return workflowStub as IWorkflow; }
	get workflow$() {return of(this.workflow) as Observable<IWorkflow>; }
	get workflowCategories() : WorkflowCategory[] { return [].concat(menuDataStub); }
}

const initialState = { appstatesettings: {
	activeProjectID: 'proj',
	activeParticipantID: 'pid',
}};


@Component({
	selector: 'app-distraction-free-wizard-showcase',
	templateUrl: './distraction-free-wizard-showcase.component.html',
	styleUrls: [
		'./../../../workflow/components/navigator/wizard-view/wizard-view.component.scss' ,
		'./distraction-free-wizard-showcase.component.scss'
	],
	providers: [
		{ provide: WorkflowRestService, useClass: WorkflowRestServiceStub },
		{ provide: WorkflowService, useClass: workflowServiceStub },
		provideMockStore({ initialState }),
	],
})
export class DistractionFreeWizardShowcaseComponent {

	pageId: number;
	hasNextPage: boolean;
	hasPreviousPage: boolean;
	workflow: IWorkflow;
	workflowItem: IQuestionnaireWorkflowItem;
	page: WizardPage;
	pages: WizardPage[];
	isFullscreen: boolean;

	@ViewChild(WorkflowItemDirective)
	public directive: WorkflowItemDirective;

	item: SessionItemData;

	constructor(
		private distractionFreeWizardService: DistractionFreeWizardService,
	) {
		this.hasNextPage = true;
		this.hasPreviousPage = false;
		this.workflow = workflowStub as IWorkflow;
		this.workflowItem = this.workflow.items[0] as IQuestionnaireWorkflowItem;
		this.pages = this.distractionFreeWizardService.processedWorkflow(this.workflowItem, null);
		this.setPage(0);
	}

	setPage(newPage: number): void {
		this.pageId = newPage;
		this.page = this.pages[this.pageId];
		this.hasPreviousPage = this.pageId > 0;
		this.hasNextPage = this.pageId < this.pages.length - 1;
	}

	toggleFullscreen(): void {
		this.isFullscreen = !this.isFullscreen;
	}
}
